import { FC } from 'react';
import { Grid, GridItem } from '@chakra-ui/react';

import { formatAmount } from 'common/formatAmount';
import SunshineCard from 'components/_core/SunshineCard';
import SquircleIcon from 'components/_core/SunshineSquircleIcon';
import Text from 'components/_core/Text';

import locales from './locales';

interface TopCardProps {
  totalAmount: number;
  remainingBalance: number;
}

const TopCard: FC<TopCardProps> = ({ remainingBalance, totalAmount }) => (
  <SunshineCard>
    <SunshineCard.Content>
      <Grid
        alignItems="center"
        columnGap="space-16"
        templateColumns="auto 1fr"
        templateRows="auto auto"
      >
        <GridItem
          colSpan={1}
          display="flex"
          justifyContent="center"
          rowSpan={2}
        >
          <SquircleIcon name="card-recto" />
        </GridItem>
        <GridItem colSpan={1} rowSpan={1}>
          <Text as="span" fontWeight="weight-500" size="lg" variant="primary">
            {`${formatAmount({ forcePlusSign: false, value: totalAmount })} ${
              locales.inTotal
            }`}
          </Text>
        </GridItem>
        <GridItem colSpan={1} rowSpan={1}>
          <Text size="sm">
            {locales.formatString(
              locales.remainingBalance,
              formatAmount({ forcePlusSign: false, value: remainingBalance }),
            )}
          </Text>
        </GridItem>
      </Grid>
    </SunshineCard.Content>
  </SunshineCard>
);

export default TopCard;
